<!-- eslint-disable no-unused-vars -->
<template>
  <div v-if="anySelected">
    <ambi-separator v-if="showSeparator" class="py-4" theme="superlight" />
    <div class="flex flex-wrap gap-2">
      <span
        v-for="obj in selectedTags"
        :key="obj.key"
        @click="reset(obj.key)"
        class="SmallTag text-p3"
      >
        {{ obj.humanValue }}
        <aw-icon icon="close" class="ml-1 w-5 h-5" />
      </span>
    </div>
  </div>

  <!-- <pre>
    {{ selectedTags }}
  </pre> -->
</template>

<script setup>
// eslint-disable-next-line no-unused-vars
import * as dataCollection from './AdvancedFilters/DataCollectionList'
import ambiFilter from './AmbiFilter.js'
import { computed, defineProps } from 'vue'

defineProps({
  showSeparator: {
    type: Boolean,
    default: true
  }
})


const { defaultFilters, filtersStorage } = ambiFilter()

const watchedValues = computed(() => {
  const values = ['priceValue', 'priceSort', 'datePeriod']
  if (filtersStorage.datePeriod === 'default' || !filtersStorage.datePeriod) {
    values.push('dateRangeFrom')
    values.push('dateRangeTo')
  }
  
  return values
})
  
const defaults = defaultFilters()

const composeHumanValue = (key, value) => {
  const map = {
    priceValue: dataCollection.priceValueList,
    priceSort: dataCollection.priceSortList,
    datePeriod: dataCollection.dateValueList
  }

  if (key === 'dateRangeFrom') {
    return 'od ' + enToCzDate(value)
  }

  if (key === 'dateRangeTo') {
    return 'do ' + enToCzDate(value)
  }

  return map[key][value]?.label ?? '?'
}

const addItemToList = (list, key, defaultValue) => {
  if (filtersStorage[key] && filtersStorage[key] !== defaultValue) {
    // eslint-disable-next-line no-undef
    list.push({
      key: key,
      humanValue: composeHumanValue(key, filtersStorage[key]),
      selectedValue: filtersStorage[key],
      defaultValue: defaultValue
    })
  }
}

const selectedTags = computed(() => {
  const list = []

  watchedValues.value.forEach((key) => {
    addItemToList(list, key, defaults[key])
  })

  return list
})

const anySelected = computed(() => selectedTags.value.length > 0)

const reset = key => {
  filtersStorage[key] = defaults[key]
}

const enToCzDate = enDate => {
  const [year, month, day] = enDate.split('-')
  const formattedDate = `${day}.${month}.${year}`

  return formattedDate
}
</script>

<style lang="scss" scoped>
.SmallTag {
  @apply bg-ambi-red text-white px-3  inline-flex items-center cursor-pointer;
  border-radius: 36px;
  height: 28px;
}
</style>
